<template>
  <div class="capsule page-wrapper">
    <el-image
      class="banner"
      style="width: 100%;"
      :src="require('../../assets/cp_banner.png')"
      fit="scale-down">
    </el-image>
    <div class="container">
      <div class="row">
        <h2 class="section1">
          产品细节
        </h2>
        <el-row class="section2" :gutter="40">
          <el-col :span="12" :xs="{span: 24}">
            <img src="../../assets/cp_explain.png" alt="">
          </el-col>
          <el-col :span="12" :xs="{span: 24}">
            <div class="text">
              <p>穿孔设计，可用各类挂绳 方便、安全、美观性强。</p>
              <p>精选材质、无忧测温</p>
              <p>专业感温探头，胶囊电子 体温计运用了专业的感温 探头，更适用于人体体温。</p>
            </div>
          </el-col>
        </el-row>
        <h2 class="section1">
          产品配件
        </h2>
        <el-row class="section3" :gutter="40">
          <el-col :span="12" :xs="{span: 24}">
            <img src="../../assets/cp_photo1.png" alt="">
          </el-col>
          <el-col :span="12" :xs="{span: 24}" class="text">
            <div class="text">
              <h3>经典包装、自带显屏</h3>
              <p>数显可以显示温度，双向展示，不用打开手机也可以 看到温度，电量显示，让充电更加方便。</p>
            </div>
          </el-col>
        </el-row>
        <el-row class="section4" :gutter="40">
          <el-col :span="12" :xs="{span: 24}">
            <div class="text">
              <h3>小巧便捷、一放即充</h3>
              <p>耳机收纳大小、随时随带、不占空间、充电读取两不误。</p>
            </div>
          </el-col>
          <el-col :span="12" :xs="{span: 24}">
            <img src="../../assets/cp_photo2.png" alt="">
          </el-col>
        </el-row>
        <el-row class="section5" :gutter="40">
          <el-col :span="12" :xs="{span: 24}">
            <div class="plain">
              <p><span>尺寸</span><span>35mmx5mm</span></p>
              <p><span>温度</span><span>-20℃ - 100℃</span></p>
              <p><span>精度</span><span>25℃~45℃± 0.2℃</span></p>
              <p><span>性能</span><span>全密封、防尘、防水</span></p>
              <p><span>充电时间</span><span>一小时</span></p>
              <p><span>使用时间</span><span>连续48小时，待机7天</span></p>
              <p><span>附带配件</span><span>充电座、挂绳</span></p>
              <p><span>产品重量</span><span>约3g</span></p>
              <p><span>包装尺寸</span><span>50*50*36mm</span></p>
            </div>
          </el-col>
          <el-col :span="12" :xs="{span: 24}">
            <img src="../../assets/cp_photo3.png" alt="">
          </el-col>
        </el-row>
        <h2 class="section1">
          产品APP
        </h2>
        <el-row class="section4" :gutter="40">
          <el-col :span="12" :xs="{span: 24}">
            <div class="text">
              <h3>实时显示  体温数值</h3>
              <p>通过AIMORE APP，连接胶囊温度计，可实时显示测温 进展及体温数值。曲线波动，视觉更直观清晰。实时上 传，放心方便</p>
            </div>
          </el-col>
          <el-col :span="12" :xs="{span: 24}">
            <img src="../../assets/cp_photo4.png" alt="">
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.section1 {
  font-size: 38px;
  font-weight: normal;
  text-align: center;
  margin: 40px 0;
}
.section2,
.section3,
.section4,
.section5 {
  margin: 120px 0;

  .el-col {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: var(--margin-large);

    img {
      max-width: 100%;
    }

    .text {
      display: flex;
      justify-content: center;
      flex-direction: column;
      max-width: 400px;

      h3 {
        margin: 40px 0;
        text-align: center;
      }

      p {
        line-height: 1.66;
      }
    }
  }
}

.section2 {
  margin-top: 0;
}

.plain {
  width: 100%;

  p {
    padding: 0 24px;
    height: 50px;
    display: flex;
    align-items: center;
    
    span:first-child {
      display: inline-block;
      width: 4em;
      position: relative;
      text-align-last: justify;
      margin-right: 24px;
      &::after {
        content: ':';
        display: block;
        position: absolute;
        top: 0;
        right: -0.5em;
      }
    }
  }
  p:nth-child(2n + 1) {
    background-color: #ECECEC;
  }
}
</style>

